import styled from 'styled-components';
import {XCloseButtonBox} from "../../../../basic-ui-components/x-close-button/x-close-button.box";
export const DialogCloseButtonDefaultBox = styled(XCloseButtonBox)`
    width: ${props => props.theme.components.modalDialog.closeButtonSize};
    height: ${props => props.theme.components.modalDialog.closeButtonSize};
`;